import React, { useState } from 'react';

import Select from 'react-select';


const selectBoxDarkTheme = {
    container: (provided) => ({
      ...provided,
      background: '#000', // Adjust background color
      margin: "1rem",
      // zIndex:1000
    }),
    control: (provided) => ({
      ...provided,
      background: '#000', // Adjust background color
      borderColor: '#666', // Adjust border color
      fontSize: '12px'
      // zIndex: 100
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isFocused ? 'linear-gradient(65.49deg, #FCB854 7.03%, #D96534 45.79%, #DC4E4F 73.14%, #DD425D 87.94%)' : '#333', // Adjust background color when focused
      color: state.isSelected ? '#fff' : '#ccc', // Adjust text color when selected
      // zIndex: 100
    }),
    multiValue: (provided) => ({
      ...provided,
      background: '#555', // Adjust background color for multi-value container
      // zIndex: 100
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: '#ccc', // Adjust text color for multi-value label
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: '#ccc', // Adjust text color for multi-value remove icon
    }),
    input: (provided) => ({
      ...provided,
      background: '#000', // Set the background color for the input
      color: '#fff', // Set the text color for the input
    }),
    menu: provided => ({ ...provided,  zIndex: 100})
  };
  

export default function SelectBox(props) {
    //console.log("propsdkb db", props)
    
    return (
    <>
      <label htmlFor={props?.id}>{props?.label}:</label>
      <Select
        className={`basic-single ${props?.className}`}
        classNamePrefix="react-select"
        defaultValue={props?.defaultValue}
        value = {props?.value}
        isDisabled={props?.isDisabled}
        isLoading={props?.isLoading}
        isClearable={props?.isClearable}
        id = {props?.id}
        // isRtl={props?.isRtl}
        isSearchable={props?.isSearchable}
        isMulti={props?.isMulti} // Set isMulti conditionally
        name="color"
        options={props?.options}
        styles={selectBoxDarkTheme} // Apply the dark theme styles
        onChange={props?.handleSelectChange} // Attach the onChange handler
        menuPosition={'fixed'} 
      />
    </>
  )
}


